import React, { useEffect, useMemo, useState } from "react";
import { Roles, Levels } from "./../routes/Paths";
import {
  DateRangePicker,
  CheckPicker,
  Loader,
  Placeholder,
  Input,
  Table,
  Button,
  ButtonToolbar,
  SelectPicker,
} from "rsuite";
import "./Admin.scss";

//icons
import Navbar from "./../../src/components/navbar/Navbar";
import previousIcon from "./../assets/icons/previous.svg";
import nextIcon from "./../assets/icons/next.svg";
import downloadIcon from "./../assets/icons/download.svg";
import calenderIcon from "./../assets/icons/calender.svg";
import emailIcon from "./../assets/icons/email.svg";
import rupeeIcon from "./../assets/icons/rupee.svg";

import UpdateRole from "../components/modal/UpdateRole";

import {
  GetUsers,
  UpdateUserRoles 
} from "../logic/store/actions/actionConstants";

import Network from "../logic/api";
import { useDispatch, useSelector } from "react-redux";

const { Column, HeaderCell, Cell, ColumnGroup } = Table;

export default function Admin() {
  const roleData = Roles.map((item) => ({ label: item.role, value: item.id }));
  var auditionUsers = {};
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [searchText, setSearch] = useState("");
  const [activeRole, setRole] = useState([]);
  const [activeState, setState] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [activeDist, setDist] = useState([]);
  const [distData, setDistData] = useState([]);
  const [activeVillage, setVillage] = useState([]);
  const [villageData, setVillageData] = useState([]);

  const [activeDateRange, setDateRange] = useState([]);
  const [activeUser, setActiveUser] = useState({});
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const currentDate = new Date();
  const currentTimestamp = currentDate.getTime();
  const oneMonthAgoDate = new Date();
  oneMonthAgoDate.setMonth(oneMonthAgoDate.getMonth() - 2);
  const oneMonthAgoTimestamp = oneMonthAgoDate.getTime();
  let baseFilter = {
    filter: "creation-time",
    creation_ts_start: oneMonthAgoTimestamp,
    creation_ts_end: currentTimestamp,
  };

  // Add default value on page load
  useEffect(() => {
    setUserList(auditionUsers.auditionees);
    getLocation();
  }, []);

  useEffect(() => {
    getUsers(baseFilter);
    console.log("activeUser", activeUser);
    getLocation();
    console.log("userList --------", userList);
  }, []);

  useEffect(() => {
    let filter = getFilter();
    if (!isEmpty(filter)) {
      getUsers(filter);
    }
  }, [
    searchText,
    activeRole,
    activeState,
    activeDateRange,
    activeDist,
    activeVillage,
    stateData,
    locations,
    distData,
    villageData,
  ]);
  function isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  async function getLocation() {
    try {
      const response = await fetch(
        "https://tnp-utils.s3.ap-south-1.amazonaws.com/location.json"
      );
      const locations = await response.json();
      let locData = [];
      let statesArray = [];
      let temp = [];

      locations.forEach((location) => {
        Object.keys(location).forEach((state, i) => {
          statesArray.push(state);
          location[state].forEach((distObj, j) => {
            Object.keys(distObj).forEach((dist, k) => {
              distObj[dist].forEach((pinObj) => {
                Object.keys(pinObj).forEach((pin) => {
                  pinObj[pin].forEach((village) => {
                    locData.push({
                      state: state,
                      dist: dist,
                      pin: pin,
                      village: village,
                    });
                  });
                });
              });
            });
          });
        });
      });
      let stateDataObj = [...new Set(locData.map((item) => item.state))].map(
        (item) => ({ label: item, value: item })
      );
      setLocations(locData);
      setStateData(stateDataObj);
    } catch (err) {
      console.log(err);
    }
  }

  function getFilter() {
    let data = {};
    if (searchText != "" && searchText.length != 0) {
      data = {
        filter: "name-role-id",
        role_id: 0,
        name:
          searchText.charAt(0).toUpperCase() +
          searchText.slice(1).toLowerCase(),
      };
    }
    // else if (activeRole != null) {
    //   data = {
    //     filter: "role-id-audition-status",
    //     role_id: 0,
    //     aud_status: activeStatus,
    //   };
    // }
    else if (activeDateRange && activeDateRange.length != 0) {
      var fromDate = new Date(activeDateRange[0]);
      var toDate = new Date(activeDateRange[1]);
      data = {
        filter: "aud-status-aud-schedule",
        aud_status: 4,
        role_id: 0,
        aud_schedule_start: fromDate.getTime(),
        aud_schedule_end: toDate.getTime(),
      };
    } else if (
      activeState.length != 0 &&
      activeDist.length != 0 &&
      activeVillage.length != 0
    ) {
      data = {
        role_id: 0,
        filter: "state-district-block",
        state: activeState,
        district: activeDist,
        block: activeVillage,
      };
    } else if (activeState.length != 0 && activeDist.length != 0) {
      data = {
        role_id: 0,
        filter: "state-district",
        state: activeState,
        district: activeDist,
      };
    } else if (activeState.length != 0) {
      data = {
        role_id: 0,
        filter: "state",
        state: activeState,
      };
    } else {
      data = baseFilter;
    }

    return data;
  }

  function getUsers(data) {
    setLoading(true);
    dispatch(
      Network.networkCall({
        action: GetUsers,
        data: data,
      })
    ).then(function (result) {
      if (result.success) {
        setLoading(false);
        console.log("Successfully retrieved users data.", result.data.users);
        setUserList(result.data.resp.users);
      } else {
        setLoading(false);
        console.log("Failed to retrieved users data.", result);
      }
    });
  }

  const handleSearchChange = (searchText) => setSearch(searchText);
  const handleRoleChange = (role) => {
    setRole(role);
  };

  const handleStateChange = (state) => {
    if (state) {
      let data = locations.filter((l) => state.includes(l.state));
      let distData = [...new Set(data.map((item) => item.dist))].map(
        (item) => ({
          label: item,
          value: item,
        })
      );
      setState(state);
      setDistData(distData);
    } else {
      setState("");
      setDist("");
      setVillage("");
    }
  };

  const handleDistChange = (dist) => {
    if (dist) {
      let data = locations
        .filter((l) => activeState.includes(l.state))
        .filter((d) => dist.includes(d.dist));
      let villageData = [...new Set(data.map((item) => item.village))].map(
        (item) => ({ label: item, value: item })
      );
      setDist(dist);
      setVillageData(villageData);
    } else {
      setDist("");
      setVillage("");
    }
  };

  const handleVillageChange = (village) => {
    if (village) {
      setVillage(village);
    } else {
      setVillage("");
    }
  };
  const handleDateRangeChange = (dateRange) => setDateRange(dateRange);

  const handleOpen = (user) => {
    setActiveUser(user);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const updateUserRole = (user) => {
    dispatch(
      Network.networkCall({
        action: UpdateUserRoles,
        data: {
          user_id: activeUser.user_id,
          creation_ts: activeUser.creation_ts,
          privileges: user.privileges,
          level_id: user.levelId,
          is_active: true,
          role_id: user.role,
          name: activeUser.name,
          r_block: user.block,
          r_district: user.district,
          r_state: user.state,
          block_approver_id: "",
          district_approver_id: "",
          state_approver_id: "",
          ho_approver_id: "",
          other_roles: user.additionalRole,
        },
      })
    ).then((result) => {
      if (result.success) {
        setLoading(false);
        getUsers(baseFilter);
        console.log("Successfully UpdateUserRoles .", result.data);
      } else {
        setLoading(false);
        console.log("Failed to UpdateUserRoles.", result);
      }
    });
    setOpen(false);
  };

  const getRoleName = (roleId) => Roles.filter((r) => r.id == roleId)[0].role;
  const getLevelName = (levelId) =>
    Levels.filter((l) => l.id == levelId)[0].level;

  return (
    <div className="container-flude">
      <Navbar></Navbar>

      <div className="container mt-5 text-danger">
        <h4>Employees Access Application</h4>
        <div className="row mb-3 mt-4">
          <div className="col-3">
            <Input placeholder="Search" onChange={handleSearchChange} />
          </div>

          <div className="col-3">
            <DateRangePicker
              placeholder={"Filter By Dates"}
              onChange={handleDateRangeChange}
              style={{ width: "100%" }}
            />
          </div>

          <div className="col-3">
            <CheckPicker
              data={roleData}
              placeholder="Select Status"
              onChange={handleRoleChange}
              style={{ width: "100%" }}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-3">
            <SelectPicker
              data={stateData}
              placeholder="Search by State"
              onChange={handleStateChange}
              style={{ width: "100%" }}
            />
          </div>

          <div className="col-3">
            <SelectPicker
              data={distData}
              placeholder="Search By District"
              onChange={handleDistChange}
              style={{ width: "100%" }}
            />
          </div>

          <div className="col-3">
            <SelectPicker
              data={villageData}
              placeholder="Search by Block"
              onChange={handleVillageChange}
              style={{ width: "100%" }}
            />
          </div>

          <div className="col-3 text-end">
            <button className="btn btn-outline-info">
              <img src={downloadIcon} /> Download
            </button>
          </div>
        </div>
        {/* Display audition data */}
        {loading ? (
          <div style={{ display: "flex", backgroundColor: "black" }}>
            <Loader center size="md" content="Loading..." vertical />{" "}
          </div>
        ) : (
          <div className="row mt-3">
            <div className="col">
              <Table
                height={300}
                rowHeight={60}
                headerHeight={40}
                data={userList}
                onRowClick={(rowData) => {
                  console.log(rowData);
                }}
              >
                <Column width={70} align="center">
                  <HeaderCell>#</HeaderCell>
                  <Cell>{(rowData, index) => <span>{index + 1}</span>}</Cell>
                </Column>

                <Column width={200}>
                  <HeaderCell>Name</HeaderCell>
                  <Cell>
                    {(user) => <span className="location"> {user.name}</span>}
                  </Cell>
                </Column>

                <Column width={200}>
                  <HeaderCell>Phone No</HeaderCell>
                  <Cell>
                    {(user) => (
                      <span className="location"> {user.phone_number}</span>
                    )}
                  </Cell>
                </Column>

                <Column width={500}>
                  <HeaderCell>Role</HeaderCell>
                  <Cell>
                    {(user) =>
                     (user.other_roles? user.other_roles : [user.role_id]).map((role_id) => (
                        
                       
                        <div className={"role_" + role_id + " role"}>
                          {getRoleName(role_id)}
                        </div>
                  
                      ))
                    }
                  </Cell>
                </Column>

                <Column width={100}>
                  <HeaderCell>Level</HeaderCell>
                  <Cell>
                    {/* {(user) => (
                      <span className="location">
                        {getLevelName(user.levelid)}
                      </span>
                    )} */}

                    {(user) => <span className="location">-- </span>}
                  </Cell>
                </Column>

                <Column width={200} fixed="right">
                  <HeaderCell>Action</HeaderCell>
                  <Cell>
                    {(user, index) => (
                      <div className="row" key={"Action" + index}>
                        <ButtonToolbar>
                          <Button
                            size="sm"
                            appearance="ghost"
                            onClick={() => handleOpen(user)}
                          >
                            Modify Role
                          </Button>
                          <Button size="sm" appearance="default">
                            Remove
                          </Button>
                        </ButtonToolbar>
                      </div>
                    )}
                  </Cell>
                </Column>
              </Table>
            </div>
          </div>
        )}
        {/* <div className="row  mb-5 mt-3">
          <div className="col-md-4">
            <span className="pagination-text">Show rows per page </span>
            <select className="page ml-2">
              <option value="10">10</option>
              <option value="20">20</option>
            </select>
          </div>
          <div className="col-md-4">
            <div className="row">
              <div className="previous col-2">
                <img src={previousIcon} />
              </div>
              <div className="current col-4 text-center pt-2 text-dark">
                <strong>1-10 </strong> of <span>12</span>
              </div>
              <div className="next col-2">
                <img src={nextIcon} />
              </div>
            </div>
          </div>
        </div> */}

        {/*Modal for profile details*/}
        <UpdateRole
          updateRole={updateUserRole}
          modalClose={handleClose}
          open={open}
          user={activeUser}
        ></UpdateRole>
      </div>
    </div>
  );
}
